import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { getPercentage } from 'core/utils';
import { IProjectDetails } from 'projects/types';

interface IProps {
  project: IProjectDetails;
}
export const PipelineInformation = ({ project }: IProps) => {
  const { t } = useTranslation();

  return <InfoCard title={t('titlePipelineInformation')} items={items(project)} />;
};

const items = (project: IProjectDetails) => [
  {
    label: t('labelEstimatedValue'),
    value: Number(project.estimatedValue),
  },
  {
    label: t('labelConfidence'),
    value: getPercentage(project.closeConfidence, { isRawPercentage: true }),
  },
  {
    label: t('labelVerticalMarket'),
    value: project.market?.name,
  },
  {
    label: t('labelCompetitors'),
    value: project.competitors,
  },
];
